import { ArrowLeft, UserPlus, UsersRound } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function NoCustomerState({ onBack, onAddCustomer }) {
  const { t } = useTranslation();

  return (
    <section
      className="app-card overflow-hidden px-5 py-7 text-center ring-1 ring-black/[0.035]"
      aria-labelledby="no-customer-title"
    >
      <span className="inline-flex rounded-full bg-primary/10 px-3 py-1.5 text-[10.5px] font-bold uppercase tracking-[0.12em] text-primary">
        {t("entrySetup.empty_badge")}
      </span>

      <div className="relative mx-auto mt-6 flex h-20 w-20 items-center justify-center rounded-[26px] bg-primary/[0.08] text-primary">
        <UsersRound className="h-9 w-9" strokeWidth={1.8} aria-hidden="true" />
        <span className="absolute -bottom-1 -right-1 flex h-8 w-8 items-center justify-center rounded-full bg-primary text-white ring-4 ring-white">
          <UserPlus className="h-4 w-4" strokeWidth={2.4} aria-hidden="true" />
        </span>
      </div>

      <h2
        id="no-customer-title"
        className="mt-5 text-[22px] font-extrabold tracking-[-0.025em] text-ink"
      >
        {t("entrySetup.empty_title")}
      </h2>
      <p className="mx-auto mt-2 max-w-[320px] text-[13.5px] font-medium leading-6 text-muted">
        {t("entrySetup.empty_body")}
      </p>

      <div className="mt-7 space-y-3">
        <button
          type="button"
          onClick={onAddCustomer}
          className="app-primary-button flex w-full items-center justify-center gap-2 text-[14px]"
        >
          <UserPlus className="h-4 w-4" aria-hidden="true" />
          {t("entrySetup.add_customer")}
        </button>
        <button
          type="button"
          onClick={onBack}
          className="flex min-h-[48px] w-full items-center justify-center gap-2 rounded-2xl font-bold text-muted transition hover:bg-paper active:scale-[0.98]"
        >
          <ArrowLeft className="h-4 w-4" aria-hidden="true" />
          {t("entrySetup.back_dashboard")}
        </button>
      </div>
    </section>
  );
}
